<template>
  <div>
    <ValidationProvider
      v-for="field in fields"
      :key="field.name"
      :name="field.name"
      :rules="field.rules"
      v-slot="{ valid, touched, errors }"
    >
      <b-form-group :label-for="'item-' + field.name" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
        <template slot="label" v-if="field.type != 'checkbox' && field.type != 'hidden'">
          <span v-if="field.text === 'CEP'">{{ field.text }} <small class="text-muted">Pressione Tab</small> </span>
          <span v-else-if="field.type == 'checkbox_group' && field.checkboxOptions.length == 0"></span>
          <span v-else>{{ field.text }} </span>
          <span class="text-danger" v-if="field.rules && field.rules.includes('required')">*</span>
        </template>
        <b-form-input
          v-if="!field.options && field.type != 'checkbox' && field.type != 'textarea' && field.type != 'datepicker' && field.type != 'file' && field.type != 'select2' && field.type != 'checkbox_group' && field.type != 'radio_group' && field.type != 'positive_number' && field.type != 'cep' && field.type != 'hidden' && field.type != 'mask'"
          :type="field.type || 'text'"
          :id="'item-' + field.name"
          :state="!touched ? null : errors[0] ? false : (valid ? true : null)"
          @input="checkInput($event, field)"
          v-model="editing[field.name]"
          :required="field.rules && field.rules.includes('required')"
        ></b-form-input>
        <b-form-input v-if="field.type == 'positive_number'" type="number" min="0"  @keypress="positiveNumberPress" v-model="editing[field.name]"></b-form-input>
        <b-form-input v-if="field.type == 'cep'" type="text" @blur="getCep" v-model="editing[field.name]" maxlength="9"></b-form-input>
        <the-mask v-if="field.type == 'mask'" :mask="field.mask" v-model="editing[field.name]" type="text" class="form-control"></the-mask>
        <b-form-checkbox-group
          v-model="editing[field.name]"
          v-if="field.type == 'checkbox_group'"
          stacked
          :id="'item-' + field.name"
          :options="field.checkboxOptions"
          :value-field="field.value_field"
          :text-field="field.text_field"
          disabled-field="notEnabled"
        ></b-form-checkbox-group>
        <b-form-radio-group
          v-if="field.type == 'radio_group'"
          v-model="editing[field.name]"
          :id="'item-' + field.name"
          :options="field.radioOptions"
          :name="'radio-inline-' + field.name"
        ></b-form-radio-group>
        <b-form-file :required="field.rules && field.rules.includes('required')" v-model="editing[field.name]" v-if="field.type == 'file'" class="mt-3" plain></b-form-file>
        <v-select
          v-if="field.type == 'select2'"
          v-model="editing[field.name]"
          :id="'item-' + field.name"
          :reduce="item => item.pk"
          :label="field.label||'name'"
          placeholder="---------------------"
          :options="field.selectOptions"
        />
        <b-form-select
          v-if="field.options"
          v-model="editing[field.name]"
          :state="!touched ? null : errors[0] ? false : (valid ? true : null)"
          :options="field.options"
          :id="'item-' + field.name"
          :required="field.rules && field.rules.includes('required')"
        >
          <option :value='null' slot="first">Selecionar</option>
        </b-form-select>
        <b-form-checkbox
          v-model="editing[field.name]"
          :value="true"
          :unchecked-value="false"
          :id="'item-' + field.name"
          v-if="field.type == 'checkbox'"
        >{{ field.text }}</b-form-checkbox>
        <b-form-textarea
          rows="7"
          v-model="editing[field.name]"
          v-if="field.type == 'textarea'"
          :id="'item-' + field.name"
          :required="field.rules && field.rules.includes('required')"
        ></b-form-textarea>
        <datepicker
          v-if="field.type == 'datepicker'"
          v-model="editing[field.name]"
          :format="customFormatter"
          :id="'item-' + field.name"
          input-class="form-control"
          :use-utc="true"
        >
        </datepicker>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import moment from 'moment';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    Datepicker,
    vSelect,
  },
  props: ["fields", "editing"],
  methods: {
    checkInput(value, field) {
      if (field.uppercase) {
        this.editing[field.name] = value.toUpperCase();
      }
    },
    positiveNumberPress(e) {
      if (e.charCode == 45) {
        e.preventDefault();
        return false;
      }
    },
    getCep(e) {
      const { value } = e.target;

      if (value.length < 8 || value.length > 9) {
        return;
      }
      
      fetch('http://viacep.com.br/ws/' + value + '/json/')
        .then(res => res.json())
        .then(res => {
          if (res.erro) {
            this.$swal('CEP Não Encontrado', 'O CEP consultado não foi encontrado na base de dados. Tente novamente. Se o problema persistir, prossiga com o preenchimento manual do endereço.', 'error')
          } else {
            this.editing.cep = res.cep;
            this.editing.address = res.logradouro;
            this.editing.district = res.bairro;
            this.editing.city = res.localidade;
            this.editing.uf = res.uf;
          }
        });
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YY');
    }
  }
};
</script>
